import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "d638f326-f89f-4b9d-b895-a63b07d35ae2",
    content: "Plane-in-Point test",
    options: {},
  },
  {
    id: "ea7b5877-46f6-4541-9d71-17e32dc4f84d",
    content: "Polygon-sphere test",
    options: {},
  },
  {
    id: "bccfb52e-9763-47b6-9991-48dc99cce01d",
    content: "Point-in-Polygon test",
    options: {},
  },
  {
    id: "1b9af900-f45c-40e5-8258-06028be49ac9",
    content: "Regression plane calculation",
    options: {},
  },
];

export const task: Task = {
  id: "cdb038b1-e23e-40a3-b276-d4a842402c79",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["bccfb52e-9763-47b6-9991-48dc99cce01d"],
};
